import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const revokeInviteFromMovement = (id: string, inviteUuid: string): ReturnType => {
    return Request.post(`/workouts/movements/${id}/invites/${inviteUuid}/revoke`);
};

export default revokeInviteFromMovement;
